// extracted by mini-css-extract-plugin
export default {"wrap":"modal_wrap__2bkEI","modal":"modal_modal__ZpQ37","content":"modal_content__4-TrU","close":"modal_close__mHyVs"};